var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationLockclosedOrange = function SvgSimpleIllustrationLockclosedOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__lockclosed_orange_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".simple-illustration__lockclosed_orange_svg__cls-4{stroke-width:0}.simple-illustration__lockclosed_orange_svg__cls-6{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__lockclosed_orange_svg__cls-4{fill:#d18000}"))), /*#__PURE__*/React.createElement("path", {
    d: "M53.904 31.437H14v13.684s.385 16.626 21.232 16.498c13.684 0 18.931-12.277 19.058-17.393.127-5.115-.385-12.79-.385-12.79Z",
    style: {
      strokeWidth: 0,
      fill: "#ff7101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.966 31.31H14v14.197s1.534 15.477 17.905 15.858c0 0-13.303-3.327-14.197-18.033-.513-8.184.254-12.023.254-12.023h.004Z",
    style: {
      fill: "#bf3013",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__lockclosed_orange_svg__cls-4",
    d: "M35.104 34.637s3.454 2.174 3.454 4.475-1.534 5.115-2.429 5.374l1.92 11.769 2.941-.513-1.792-12.023s3.068-2.047 2.559-4.475c-.509-2.428-2.301-5.501-6.649-4.603l-.004-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.126 44.486s2.517-2.259 2.517-4.734-2.386-4.776-4.263-4.776-3.099 3.161-3.068 3.835c.027.678 1.11 4.009 2.471 4.946L31.482 55.95s5.285 1.11 6.565.297l-1.92-11.769v.008Z",
    style: {
      fill: "#002140",
      strokeWidth: 0
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__lockclosed_orange_svg__cls-4",
    d: "m25.255 31.183-.285-2.429s.428-.64-1.565-.64-5.408.127-5.408.127-1.137.127-1.137 1.021v1.92h8.396ZM51.772 31.183l-.285-2.429s.428-.64-1.565-.64-5.408.127-5.408.127-1.137.127-1.137 1.021v1.92h8.399-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50.92 27.644-.316-7.216S47.593 6.586 34.248 7.01c-13.341.428-16.309 13.222-16.309 13.222l-.782 7.586 7.212-.17.035-6.225s2.228-7.49 9.895-7.582c7.667-.093 9.205 7.667 9.205 7.667l.852 6.48 6.565-.339v-.004Z",
    style: {
      fill: "#e4bc07",
      strokeWidth: 0
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__lockclosed_orange_svg__cls-6",
    d: "M54.22 31.341v11.923c0 10.123-8.207 18.329-18.329 18.329s-18.329-8.207-18.329-18.329V31.341h36.659Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__lockclosed_orange_svg__cls-6",
    d: "M36.789 61.593c-16.383 0-22.755-8.207-22.755-18.333V31.337h4.645"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__lockclosed_orange_svg__cls-6",
    d: "M41.684 39.49a5.174 5.174 0 0 0-10.346 0 5.17 5.17 0 0 0 2.513 4.433l-2.575 11.819s4.387 2.586 9.672 0l-2.139-11.626a5.17 5.17 0 0 0 2.872-4.629l.004.004Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__lockclosed_orange_svg__cls-6",
    d: "m37.915 56.192-2.139-11.626a5.17 5.17 0 0 0 2.872-4.63 5.174 5.174 0 0 0-4.132-5.069M16.69 31.09v-1.893c0-.632.59-1.141 1.318-1.141h5.929c.729 0 1.318.513 1.318 1.141v1.893M43.207 31.09v-1.893c0-.632.59-1.141 1.318-1.141h5.929c.728 0 1.318.513 1.318 1.141v1.893M24.365 28.056v-4.684c0-5.458 4.425-9.88 9.88-9.88s9.88 4.425 9.88 9.88v4.641"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__lockclosed_orange_svg__cls-6",
    d: "M50.92 28.01v-4.329c0-9.209-7.463-16.672-16.672-16.672S17.58 14.472 17.58 23.681v4.375"
  })));
};
export default SvgSimpleIllustrationLockclosedOrange;